import { useState } from "react";
import { Card, PageHeader, Btn } from "../../components/shared/UIComponents";
import { AdminMgmtAPI } from "../../services/api";

export default function SACreate({ onAdd, editData, onEditDone }) {
  const blank = { name:"", email:"", password:"", confirmPassword:"", phone:"", society:"", city:"", state:"Maharashtra" };
  const [f, setF]       = useState(editData ? { ...editData, password:"", confirmPassword:"" } : blank);
  const [errs, setErrs] = useState({});
  const [saving, setSaving] = useState(false);
  const [ok, setOk]     = useState(false);
  const [apiErr, setApiErr] = useState(null);
  const [sp, setSp]     = useState(false);
  const set = k => e => setF(p => ({ ...p, [k]: e.target.value }));

  const validate = () => {
    const e = {};
    if (!f.name.trim())     e.name     = "Name required";
    if (!f.email.includes("@")) e.email = "Valid email required";
    if (!editData && !f.password)              e.password = "Password required";
    if (!editData && f.password !== f.confirmPassword) e.confirmPassword = "Passwords don't match";
    return e;
  };

  const submit = async () => {
    const e = validate();
    if (Object.keys(e).length) { setErrs(e); return; }
    setErrs({}); setSaving(true); setApiErr(null);
    try {
      let result;
      if (editData) {
        result = await AdminMgmtAPI.updateStatus(editData.id, { active: true });
        if (onEditDone) onEditDone();
      } else {
        result = await AdminMgmtAPI.create({ name: f.name, email: f.email, password: f.password });
      }
      if (onAdd) onAdd(result || { ...f, id: Date.now() });
      setOk(true);
      if (!editData) setF(blank);
      setTimeout(() => setOk(false), 3000);
    } catch(err) { setApiErr(err.message); }
    finally { setSaving(false); }
  };

  const FI = ({ label, k, type="text", ph="" }) => (
    <div>
      <label style={{ display:"block", fontSize:11, fontWeight:700, color:"#546e7a", marginBottom:5, textTransform:"uppercase" }}>{label}</label>
      <input type={(k==="password"||k==="confirmPassword")?(sp?"text":"password"):type} value={f[k]||""} onChange={set(k)} placeholder={ph}
        style={{ width:"100%", padding:"10px 12px", border:`1.5px solid ${errs[k]?"#f44336":"#e0e0e0"}`, borderRadius:8, fontSize:13, boxSizing:"border-box", outline:"none" }}
        onFocus={e=>e.target.style.borderColor="#1565c0"} onBlur={e=>e.target.style.borderColor=errs[k]?"#f44336":"#e0e0e0"} />
      {errs[k] && <div style={{ color:"#f44336", fontSize:11, marginTop:4 }}>⚠ {errs[k]}</div>}
    </div>
  );

  return (
    <Card>
      <PageHeader title={editData?"Edit Admin":"Create New Admin"} sub={editData?`Editing: ${editData.name}`:"Register a new admin account"} />
      <div style={{ padding:24 }}>
        {ok && <div style={{ padding:"10px 14px", background:"#e8f5e9", color:"#2e7d32", borderRadius:8, marginBottom:16, fontSize:13 }}>✓ {editData?"Admin updated!":"Admin created successfully!"}</div>}
        {apiErr && <div style={{ padding:"10px 14px", background:"#fce8e6", color:"#c62828", borderRadius:8, marginBottom:16, fontSize:13 }}>⚠ {apiErr}</div>}
        <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:16 }}>
          <FI label="Full Name" k="name" ph="Enter full name" />
          <FI label="Email" k="email" type="email" ph="admin@example.com" />
          {!editData && <>
            <div style={{ position:"relative" }}>
              <FI label="Password" k="password" ph="Min 8 characters" />
            </div>
            <FI label="Confirm Password" k="confirmPassword" ph="Re-enter password" />
          </>}
          <FI label="Phone" k="phone" ph="10-digit mobile" />
          <FI label="Society Name" k="society" ph="Society name" />
          <FI label="City" k="city" ph="City" />
          <div>
            <label style={{ display:"block", fontSize:11, fontWeight:700, color:"#546e7a", marginBottom:5, textTransform:"uppercase" }}>State</label>
            <select value={f.state} onChange={set("state")} style={{ width:"100%", padding:"10px 12px", border:"1.5px solid #e0e0e0", borderRadius:8, fontSize:13, outline:"none" }}>
              {["Maharashtra","Delhi","Gujarat","Karnataka","Tamil Nadu","Rajasthan"].map(s=><option key={s}>{s}</option>)}
            </select>
          </div>
        </div>
        <div style={{ marginTop:20, display:"flex", gap:10, alignItems:"center" }}>
          <Btn onClick={submit} disabled={saving}>{saving?"Saving…":editData?"Update Admin":"Create Admin"}</Btn>
          {editData && <Btn bg="#78909c" onClick={onEditDone}>Cancel</Btn>}
          <label style={{ fontSize:12, color:"#78909c", cursor:"pointer", display:"flex", alignItems:"center", gap:5 }}>
            <input type="checkbox" checked={sp} onChange={e=>setSp(e.target.checked)} style={{ cursor:"pointer" }} /> Show passwords
          </label>
        </div>
      </div>
    </Card>
  );
}
